import * as React from 'react';

import {
  concatStyleSets,
  IStyleFunctionOrObject,
  ITextFieldStyleProps,
  ITextFieldStyles,
  ITheme,
  memoizeFunction,
} from '@fluentui/react';
import { EventGroup, KeyCodes } from '@fluentui/react/lib/Utilities';

import { AppInput, AppInputProps } from '@1js/acui-input';
import { AppThemeConsumer } from '@1js/acui-theme';

import { getRibbonInputStyles } from './RibbonInput.styles';
const getStyles = memoizeFunction(
  (
    theme: ITheme,
    width: number | undefined,
    styles?: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles>
  ) => {
    return concatStyleSets(getRibbonInputStyles(theme, width), styles);
  }
);

export class RibbonInput extends React.PureComponent<AppInputProps, {}> {
  // VSTS: 3994572 - InputBox: ESC is not cancelling a pending value and is instead submitting the value
  // Reference: https://office.visualstudio.com/OC/_wiki/wikis/OC.wiki/9723/Event-propagation-mixing-React-Synthetic-Events-and-native-events
  private ribbonInputWrapper = React.createRef<HTMLDivElement>();
  private appInput = React.createRef<AppInput>();
  private events: EventGroup;
  private keydown: string = 'keydown';

  constructor(props: AppInputProps) {
    super(props);
    // create an instance of EventGroup
    this.events = new EventGroup(this);
  }
  public componentDidMount() {
    this.events.on(this.ribbonInputWrapper.current, this.keydown, this.onKeyDown);
  }

  public componentWillUnmount() {
    this.events.off();
  }
  private onKeyDown = (e: React.KeyboardEvent<HTMLElement>): void => {
    if (e.which === KeyCodes.escape) {
      this.appInput.current?.resetState();
      e.stopPropagation();
      e.preventDefault();
    }
  };

  public render() {
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => {
          const styles = getStyles(theme, this.props.width, this.props.styles);
          return (
            <div ref={this.ribbonInputWrapper}>
              <AppInput {...this.props} styles={styles} ref={this.appInput} />
            </div>
          );
        }}
      </AppThemeConsumer>
    );
  }
}
